import { render, staticRenderFns } from "./TransactionEditor.vue?vue&type=template&id=23c644d2"
import script from "./TransactionEditor.vue?vue&type=script&lang=js"
export * from "./TransactionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports